export const rdWidget = {
  transclude: true,
  template: `<div class="widget" ng-transclude></div>`,
};
